import React from 'react';
import { func, string } from 'prop-types';
import cx from 'classnames';
import { SectionPropTypes } from './../Section';

import { Section, Grid, GridCol, Bar, BarItem, Button, Icon } from './../';

const propTypes = {
  /** Redirect link for banner */
  link: string,
  /** Background color */
  color: SectionPropTypes.color,
  /** Function to render icon element */
  renderIcon: func,
};

const CLASS_ROOT = 'banner';

const Banner = ({
  children,
  className,
  link,
  renderIcon = () => {},
  ...other
}) => {
  const classes = cx(CLASS_ROOT, className);

  const icon = renderIcon() || (
    <Icon
      name="arrow-special-left"
      className="text-color-primary"
      size="xlarge"
    />
  );

  return (
    <Section className={classes} {...other}>
      <Grid>
        <GridCol
          className="pl-none"
          size={{ xs: 23, l: 19 }}
          offset={{ xs: 'center', l: 6 }}
        >
          <Bar className="mb-none">
            <BarItem>
              <a href={link}>{children}</a>
            </BarItem>
            <BarItem className="align-self-right">
              <Button size="large" padded href={link} className="mb-xsmall">
                {icon}
              </Button>
            </BarItem>
          </Bar>
        </GridCol>
      </Grid>
    </Section>
  );
};
Banner.displayName = 'Banner';
Banner.propTypes = propTypes;

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.js